import React, { MouseEventHandler } from "react";
import { StyledIconManager } from "./IconManager.styled";
import { IconSizeEnum } from "../../../types/AppTypes";

type IconManagerProps = {
  children: React.ReactNode;
  size: IconSizeEnum;
  color?: string;
  marginRight?: number;
  fill?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
  noStrokeColor?: boolean;
  id?: string;
};
export const IconManager = ({
  children,
  size,
  color,
  marginRight,
  fill,
  onClick,
  disabled,
  noStrokeColor,
  id,
}: IconManagerProps) => {
  return (
    <StyledIconManager
      $size={size}
      $color={color}
      $noStrokeColor={noStrokeColor}
      $marginRight={marginRight}
      $fill={fill}
      onClick={disabled ? undefined : onClick}
      data-testid="icon-test"
      disabled={disabled}
      id={id}
    >
      {children}
    </StyledIconManager>
  );
};
